import { LinkedIn, Instagram, Facebook, Mail } from '@mui/icons-material'

interface Props { }

function SocialLink(props: Props) {
    function goTo(link: string) {
        window.open(link)
    }

    return (

        <div className='ibg-social'>
            <button aria-label="LinkedIn" onClick={() => { goTo("") }}><LinkedIn /></button>
            {/* <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='inherit'><GitHub /></IconButton> */}
            <button aria-label="Instagram" onClick={() => { goTo("") }}><Instagram /></button>
            <button aria-label="Facebook" onClick={() => { goTo("") }}><Facebook /></button>
            <button aria-label="Email" onClick={() => { window.location.href = "mailto:contact@ibgalphatech.com" }}><Mail /></button>
        </div>
    )
}

export default SocialLink
